import React, { FC } from 'react';

type PropsType = {
  uid: string;
  usr: string;
};
export const ParticipantsItem: FC<PropsType> = ({ uid, usr }: PropsType) => {
  return (
    <div className="list-participants__card" key={uid}>
      <img
        className="list-participants__player-avatar avatar"
        src={`https://www.gamecolony.com/cgi-bin/get_avatar.plx?uid=${uid}&size=2`}
        alt="avatar"
      />
      <div className="list-participants__player-name">{usr}</div>
    </div>
  );
};
